__turbopack_context__.v({
  "root": "TableList-module__fUz5sW__root",
  "row": "TableList-module__fUz5sW__row",
  "rowDivider": "TableList-module__fUz5sW__rowDivider",
});
